export default __webpack_public_path__ + "static/media/giftUser.0d976390.png";